import cn from 'classnames';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { tradingFeeDiscount } from 'helpers/formulas';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { device } from 'helpers/screenSizes';
import subscribe from 'HOC/subscribe';
import { detoMSPSelector, walletSpotPriceBySymbol } from 'selectors';
import Balloons from 'styles/assets/fee_banner_ballons.svg';

const BannerWrapper = styled.div`
  width: 100%;

  a {
    display: block;
  }

  .fee-banner {
    display: flex;
    justify-content: space-between;
    background: ${props => props.theme.primaryTheme};
    width: 100%;
    height: 52px;
    padding: 3px 10px 6px 10px;
    overflow: hidden;
    border-radius: 4px;

    .text {
      padding-top: 3px;
    }

    &.long-text {
      height: 42px;
      padding: 0px 12px;
      .text {
        display: flex;
        align-items: center;

        p {
          font-size: 12.1px;
        }
      }

      img {
        width: 40px;
        height: 40px;
        bottom: -5px;
        margin-right: 0px;
      }
    }

    p {
      font-family: var(--fontRegular);
      font-style: normal;
      font-size: 14px;
      line-height: 20px;
      color: white;

      span {
        font-family: var(--fontRegular);
        color: #ffe500;
        letter-spacing: 0.4px;
      }
    }

    img {
      width: 50px;
      height: 50px;
      position: relative;
      margin-right: 5px;
    }
  }

  @media ${device.down.md} {
    .fee-banner {
      padding: 3px 15px 6px 15px;
    }
  }
`;

const EnableFeeBanner = subscribe(props => {
  const { longText } = props;
  const detoSpotPrice = walletSpotPriceBySymbol('.DEDETOUSDT');
  const detoMSP = useSelector(detoMSPSelector);
  const percentage = tradingFeeDiscount(detoSpotPrice, detoMSP);

  if (Number.isNaN(percentage) || percentage <= 0) {
    return null;
  }

  return (
    <BannerWrapper>
      <Link
        data-testid="feeDiscountBanner-profileMenuMobile"
        to="/account/preferences"
        onClick={() => trackMixpanelEvent('Fee Discount Banner Clicked')}
      >
        <div className={cn('fee-banner', { 'long-text': longText })}>
          <div className="text">
            <p>
              Enjoy <span>{isNaN(percentage) ? '-' : percentage}% discount&nbsp;</span>
            </p>
            <p>when you pay fees in DETO</p>
          </div>
          <img src={Balloons} alt="Balloons" />
        </div>
      </Link>
    </BannerWrapper>
  );
});

export default EnableFeeBanner;
